import request from '../utils/request'

export function ExportExcelRequest(data) {
  return request({
    url: 'dashboard/download/excel',
    method: 'post',
    data,
    responseType: 'blob',
    headers: { 'Accept': 'application/vnd.ms-excel;charset=utf-8' }
  })
}

